module.exports = __webpack_public_path__ + "img/dszh.b9462b96.jpg";